import { Outlet } from 'react-router-dom';
export const PeriodReviewOutlet = () => <Outlet />;
